import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
/** Whether the given pathname belongs to the given route segment. */
function isOnRoute(pathname, route) {
  return pathname.includes(`/${route}`);
}

/**
 * Watches the current location and opens a dialog when the user navigates away
 * from a given sidebar route section (e.g. to gather feedback on exit).
 * Reusable for any sidebar item by passing a different `route` and `renderDialog`.
 */
export function SidebarRouteExitDialog(t0) {
  const $ = _c(8);
  const {
    route,
    renderDialog,
    canOpen
  } = t0;
  const {
    pathname
  } = useLocation();
  const previousPathnameRef = useRef(pathname);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== canOpen || $[1] !== pathname || $[2] !== route) {
    t1 = () => {
      const hasLeftRoute = isOnRoute(previousPathnameRef.current, route) && !isOnRoute(pathname, route);
      previousPathnameRef.current = pathname;
      if (hasLeftRoute && (canOpen?.() ?? true)) {
        setIsDialogOpen(true);
      }
    };
    t2 = [pathname, route, canOpen];
    $[0] = canOpen;
    $[1] = pathname;
    $[2] = route;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isDialogOpen) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsDialogOpen(false);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== renderDialog) {
    t4 = renderDialog(t3);
    $[6] = renderDialog;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}